import { useEffect, useState } from "react";
import { getAvailableMonths } from "./api";
import type { MonthStatus } from "./types";

export interface AvailableMonths { months: string[]; statuses: MonthStatus[] }

const EMPTY: AvailableMonths = { months: [], statuses: [] };

export function useAvailableMonths(): AvailableMonths {
  const [state, setState] = useState<AvailableMonths>(EMPTY);
  useEffect(() => {
    let cancelled = false;
    getAvailableMonths()
      .then(r => { if (!cancelled) setState({ months: r.months, statuses: r.statuses ?? [] }); })
      .catch(() => { /* non-fatal: keep empty */ });
    return () => { cancelled = true; };
  }, []);
  return state;
}
